





















































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { FormatObjectSelector, FormatObjectSelectorColumnTypes } from "../selectors";
import { IExpressionRangeSpecifiable, ILinkedObjectSpecifiable } from "../../../../../../../documaker/domain/format/objects";

@Component({
  components: {
    FormatObjectSelector
  }
})
export default class DateDurationSelectDialog extends Mixins(DialogMixin) {
  selectedFrom: ILinkedObjectSpecifiable = null;
  selectedTo: ILinkedObjectSpecifiable = null;
  selectionObjects: ILinkedObjectSpecifiable[] = [];
  dialogTitle: string = "";
  fromTitle: string = "";
  toTitle: string = "";
  toCellString: (column: FormatObjectSelectorColumnTypes, row: ILinkedObjectSpecifiable) => string = () => "";
  confirmed: boolean = false;

  $refs!: {
    from: FormatObjectSelector,
    to: FormatObjectSelector,
  };

  get columns(): FormatObjectSelectorColumnTypes[] {
    return ["key", "id"];
  }

  async show(param: {
      from: ILinkedObjectSpecifiable,
      to: ILinkedObjectSpecifiable,
      selectionObjects: ILinkedObjectSpecifiable[],
      dialogTitle: string,
      fromTitle: string,
      toTitle: string,
      toCellString: (column: FormatObjectSelectorColumnTypes, row: ILinkedObjectSpecifiable) => string,
    }): Promise<IExpressionRangeSpecifiable<ILinkedObjectSpecifiable>> {
    return this.showModal(async () => {
      this.selectedFrom = ObjectUtility.copyDeeply(param.from);
      this.selectedTo = ObjectUtility.copyDeeply(param.to);
      this.selectionObjects = param.selectionObjects;
      this.dialogTitle = param.dialogTitle;
      this.fromTitle = param.fromTitle;
      this.toTitle = param.toTitle;
      this.toCellString = param.toCellString;
      this.confirmed = false;
      this.initCurrentRow();
      await this.waitHidden();
      const ret = this.confirmed
        ? { from: this.selectedFrom, to: this.selectedTo }
        : undefined;
      this.selectedFrom = null;
      this.selectedTo = null;
      this.selectionObjects = [];
      this.dialogTitle = "";
      this.fromTitle = "";
      this.toTitle = "";
      return ret;
    });
  }

  private initCurrentRow() {
    const fromIndex = this.toSelectionIndex(this.selectedFrom);
    const toIndex = this.toSelectionIndex(this.selectedTo);
    this.$nextTick(() => {
      this.$refs.from.setCurrentRow(fromIndex >= 0 ? fromIndex : undefined);
      this.$refs.to.setCurrentRow(toIndex >= 0 ? toIndex : undefined);
    });
  }

  private toSelectionIndex(value: ILinkedObjectSpecifiable): number {
    return value
      ? this.selectionObjects.findIndex(v =>
        v.id === value.id &&
        v.key === value.key)
      : -1;
  }

  changeFromObject(value: ILinkedObjectSpecifiable) {
    this.selectedFrom = value;
  }

  changeToObject(value: ILinkedObjectSpecifiable) {
    this.selectedTo = value;
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
